// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import pomodoroReducer from './slices/pomodoroSlice';
import toastReducer from './slices/toastSlice';
import hierarchyReducer from './slices/hierarchySlice';
import reviewRequestReducer from './slices/reviewRequestSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    pomodoro: pomodoroReducer,
    toast: toastReducer,
    hierarchy: hierarchyReducer,
    reviewRequest: reviewRequestReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
